<template>
  <div :style="pureBaseStyle">
    <div :class="getCss('login-box')" :style="styles.base">
      <div :class="getCss('login')" :style="styles.fontStyle" v-if="isLogin">
        <div :class="getCss('userinfo-text-up')">
          你好，
          <template>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && isWX" v-html="userName"></span>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && !isWX" v-text="userName"></span>
            <span :class="getCss('userinfo-text')">{{ partitionName }}</span>
            <span :class="getCss('userinfo-text')">{{ roleName }}</span>
          </template>
        </div>
        <div :class="getCss('line-box')" :style="loginLineStyle"></div>
        <div :class="getCss('userinfo-text-down')">
          <template v-if="showRole">
            <a :class="getCss('userinfo-text-button')" @click="handleBindRole">{{ userBindText }}
            </a>
          </template>
          <a v-if="!configurationData.disableRewardRecord" :class="getCss('userinfo-text-button')"
            @click="handleClaimRecord">领奖记录</a>
          <a v-if="!configurationData.disableRechargeRecord" :class="getCss('userinfo-text-button')"
            @click="handleRechargeRecord">充值记录</a>
          <!--<br v-if="configurationData.showBindQQ &&
             configurationData.showBindPhone && configurationData.showAccessMakeAppShortCut">-->
          <a v-if="configurationData.showBindQQ" :class="getCss('userinfo-text-button')" @click="showBindQQFunc">{{
            bindBtnText }}</a>
          <a v-if="configurationData.showBindClub" :class="getCss('userinfo-text-button')"
            @click="showBindClubFunc">绑定俱乐部</a>
          <a v-if="configurationData.showBindPhone" :class="getCss('userinfo-text-button')"
            @click="showBindPhoneFunc">绑定手机</a>
          <a v-if="configurationData.showAccessMakeAppShortCut" :class="getCss('userinfo-text-button')"
            @click="showAccessMakeAppShortCutFunc">添加快捷方式</a>
          <a :class="getCss('userinfo-text-button')" v-if="!configurationData.disableChangeLogin"
            @click="change">切换登录方式</a>
          <a :class="getCss('userinfo-text-button')" v-if="showLogout" @click="handleLogout">注销</a>
        </div>
      </div>
      <div :class="getCss('not-login')" v-else :style="styles.fontStyle">
        <span>
          <a @click="showLogin">HI~，请登录</a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { baseComponents, common, componentBaseMixin } from '@tencent/ceiba-base-components';
// import { baseComponents, common, componentBaseMixin } from '../../../../ceiba-base-components';
import handlerImposeLoginType from '@tencent/ceiba-base-components/src/components/user-login-component/handlerImposeLoginType';
import {
  LOGIN_ONLY_WITH_QQ,
  LOGIN_ONLY_WITH_WX,
} from '@tencent/ceiba-base-components/src/components/user-login-component/constant';

export default {
  name: 'CCommercialUserAreaFlatten',
  components: {
  },
  filters: {
    base64decode(value) {
      return common.tool.Base64.decode(value);
    },
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      cssPrefix: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        ? 'commercial-user-area-flatten-h5-' : 'commercial-user-area-flatten-pc-',
      gameCode: '',
      showBindRoleTag: false,
      loginStatus: '',
    };
  },
  computed: {
    pureBaseStyle() {
      return {
        left: this.styles.base.left,
        top: this.styles.base.top,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    loginLineStyle() {
      console.log(this?.styles?.loginLineStyle?.width, 'width');
      const width1 = this?.styles?.loginLineStyle?.width || (this.isMobile ? '5.98rem' : '598px');
      const color = this?.styles?.loginLineStyle?.backgroundColor || '#FFFFFF';
      return {
        // ...loginLine,
        width: width1,
        border: this.isMobile ? `0.01rem solid ${color}` : `1px solid ${color}`,
      };
    },
    bindBtnText() {
      return this.configurationData.bind_btn_text || '绑定QQ';
    },
    isWX() {
      //  ios safari | 心悦app | wx客户端
      const isWxCookie = common.tool.getCookie('acctype') === 'wx';
      return isWxCookie ? isWxCookie : this.$platform.isWX;
    },
    isSafari() {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    },
    // 隐藏注销按钮
    cLogout() {
      console.log(common.tool.getQueryparams('C_LOGOUT'));
      if (common.tool.getQueryparams('C_LOGOUT')) {
        return true;
      }
      return false;
    },
    // 是否在游戏内
    isInGame() {
      return common.platform.isGame;
    },
    showLogout() {
      if (this.cLogout || this.isInGame) {
        return false;
      }
      const isShanxianApp = /com\.tencent\.gamecommunity/.test(window.navigator.userAgent);
      const isBbApp = !!window.navigator.userAgent.match(/gamehelper/i);
      if (isShanxianApp || isBbApp) {
        return false;
      }
      return this.$actInfo && !this.$ast.isAPP();
    },
    showRole() {
      const buShanDang = this.actInfo.extendConfig?.bushandang || false;
      if (buShanDang) {
        return this.isRoleStatusValid;
      }
      return this?.actInfo?.extendConfig?.forceRole;
    },
    userBindText() {
      return this.isRoleReady ? '更改绑定' : '绑定角色';
    },
    userName() {
      return this.isLogin ? this.userInfo.nickName : '';
    },
    userAvatar() {
      return this.isLogin ? this.userInfo.avatar : '';
    },
    partitionName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
    },
    roleName() {
      if (this.isRoleReady) {
        return common.tool.Base64.decode(this.roleInfo.role_name || '');
      }
      return '';
    },
    /**
     * 限制登录 0不限，1仅限微信，2仅限QQ
     * @returns {number}
     */
    imposeLogin() {
      const { imposeLogin = 0, needWXLogin } = this.configurationData;
      return handlerImposeLoginType({
        imposeLoginType: Number(imposeLogin),
        needWXLogin,
      });
    },
  },
  watch: {
    loginStatus: {
      async handler(newVal) {
        if (this.$isInEditor) return;
        console.log('watch  loginStatus', newVal);
        await this.doSleep(2000);
        await this.handleLoginPop();
      },
    },
  },
  async mounted() {
    console.log(this.isMobile, 'isMobile');
    console.log('configurationData=', this.configurationData);
    console.log('isRoleReady==', this.isRoleReady);
    await this.initialize();
    if (this.$isInEditor && !this.isInPreview) return;
    if (!this.isLogin && !this.$ast.isAPP()) {
      this.reportExposeFunc('login_expose', { type: 'flatten_nologin' });
    }
    this.$eventBus.$on('ceiba:custom:events:pull-user-area-login', () => {
      const { imposeLogin = 0, needWXLogin } = this.configurationData;
      baseComponents.userLoginComponent.showUserLoginPopup({
        imposeLoginType: Number(imposeLogin),
        needWXLogin,
        option: {
          cid: this.cid,
          uid: this.uid,
          uname: this.uname,
        },
      });
    });
    this.$eventBus.$on('ceiba:common:events:bind-role', () => {
      this.reportReturnGameFlow(this.roleInfo);
    });
  },
  methods: {
    async initialize() {
      if (this.$isInEditor && !this.isInPreview) return;
      this.$onClickLogin(({ loginType }) => {
        console.log('【CCommercialUserAreaFlatten】onClickLogin loginType = ', loginType);
        if (loginType === 'wx') {
          this.wxLogin();
          return;
        }
        if (loginType === 'qq') {
          this.qqLogin();
          return;
        }
      });
      this.$eventBus.$onLogined(this.imposeLoginTips);
      this.gameCode = this.configurationData.game_code ? this.configurationData.game_code : this.actInfo.game_code;
      this.loginStatus = this.isLogin;
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    async handleLoginPop() {
      const { isActionShowLoginDialog } = this.configurationData;
      if (!isActionShowLoginDialog) return;
      if (!this.$ast.isAPP()) {
        if (!this.isLogin) {
          this.showLogin();
        } else {
          this.$eventBus.$emit('ceiba:custom:events:close-user-login-popup');
        }
      }
    },
    showLogin() {
      if (this.$isInEditor && !this.isInPreview) return;
      baseComponents.userLoginComponent.login();
      if (!this.$ast.isAPP()) {
        this.reportFunc('login_click', { type: 'flatten_nologin' });
      }
    },
    change() {
      if (this.$ast.isAPP()) {
        this.logout();
      } else {
        const { imposeLogin = 0, needWXLogin } = this.configurationData;
        baseComponents.userLoginComponent.showUserLoginPopup({
          imposeLoginType: Number(imposeLogin),
          needWXLogin,
          option: {
            cid: this.cid,
            uid: this.uid,
            uname: this.uname,
            mode: 'change',
          },
        });
      }
      this.reportFunc('login_click', { type: 'flatten_change' });
    },
    wxLogin() {
      if (this.imposeLogin === LOGIN_ONLY_WITH_QQ) {
        return;
      }
      // 闪现登录
      if (this.astConfigInfo && this.astConfigInfo?.NAME === 'spark') {
        if (!this.$ast.isAPP() && this.configurationData.forceApp === true) {
          this.$ast.gotoAPP();
          return;
        }
        this.login({
          loginType: 'wx',
        });
        // 其他业务登录
      } else {
        this.login({
          loginType: 'wx',
        });
      }
      this.handleClickEvent();
      console.log('【commercial-user-area-flatten】wxLogin');
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'wx' });
    },
    qqLogin() {
      if (this.imposeLogin === LOGIN_ONLY_WITH_WX) {
        return;
      }
      // 闪现登录
      if (this.astConfigInfo && this.astConfigInfo?.NAME === 'spark') {
        if (!this.$ast.isAPP() && this.configurationData.forceApp === true) {
          this.$ast.gotoAPP();
          return;
        }

        if (!this.isLogin) {
          if (!this.$ast.isAPP()) {
            this.login({
              loginType: 'qq',
            });
          } else {
            window.SX_WEB.auth.login('qc');
          }
          return;
        }
        // 其他业务登录
      } else {
        this.login({
          loginType: 'qq',
        });
      }
      this.handleClickEvent();
      console.log('【commercial-user-area-flatten】qqLogin');
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'qq' });
    },
    async handleLogout() {
      this.logout();
    },
    imposeLoginTips() {
      if (this.isLogin) {
        this.loginStatus = this.isLogin;
      }
      const that = this;
      const { imposeLogin = 0 } = this.configurationData;
      baseComponents.userLoginComponent.checkOnLogin({
        imposeLoginType: Number(imposeLogin),
        option: {
          cid: this.cid,
          uid: this.uid,
          uname: this.uname,
        } }).then((ret) => {
        if (ret === 0) {
          // do success
          that.handleLogin();
        }
        if (ret === 1) {
          // do confirm
          that.change();
        }
        if (ret === 2) {
          // do cancle
        }
      });
    },
    async handleLogin() {
      // 自动绑定角色
      const buShanDang = this.actInfo.extendConfig?.bushandang || false;
      if (buShanDang) {
        if (this.isRoleStatusValid) {
          await this.checkRoleInfo();
        }
      } else {
        if (this?.actInfo?.extendConfig?.forceRole) {
          await this.checkRoleInfo();
        }
      }
      this.reportExposeFunc('login_expose', { type: 'flatten_login' });
      const { isUserReported = false } = this.configurationData;
      // 只需要 微信端上报
      if (isUserReported && this.isWX) {
        const res = await this.$axiosInstance.get('https://wang.xinyue.qq.com/api/headurl/update');
        console.log(res, '登录态头像上报res');
      }
    },
    async handleBindRole() {
      try {
        if (this.showBindRoleTag === true) {
          return;
        }
        this.showBindRoleTag = true;
        const that = this;
        setTimeout(() => {
          that.showBindRoleTag = false;
        }, 1500);
        console.log('【commercial-user-area-flatten】user access click handleBindRole');
        this.reportFunc('login_click', { type: 'flatten_role' });
        baseComponents.gameRoleSelect.showGameRoleSelect(this.currentGameCode || this.actInfo.game_code, {})
          .then((roleInfo) => {
            console.log('【commercial-user-area-flatten】select role=', roleInfo);
            this.saveCurrentRole({
              isRoleReady: true,
              roleInfo,
            });
            this.reportReturnGameFlow(roleInfo);
          })
          .catch((response) => {
            console.error('action bind role fail  response =', response);
          });
      } catch (err) {
        console.error('action bind role fail catch  error =', err);
      }
    },
    // 上报回流
    reportReturnGameFlow(roleInfo) {
      const { reportReturnGameFlowId = 0 } = this.configurationData;
      if (reportReturnGameFlowId > 0 && roleInfo) {
        console.log('access report after report  role=', roleInfo, reportReturnGameFlowId);
        this.flowRequest({
          flowId: reportReturnGameFlowId,
          params: {
            role: roleInfo,
          },
        }).then(res => console.log('用户回流上报流程reportReturnGameFlowId =', reportReturnGameFlowId, '请求返回 = ', res));
      }
    },
    showBindPhoneFunc() {
      this.$eventBus.$emit('ceiba:custom:events:call:use:bind:phone:pop', {});
    },
    showBindQQFunc() {
      this.$eventBus.$emit('ceiba:common:event:account-wx-qq-fill', {});
    },
    // 拉起绑定俱乐部弹窗
    showBindClubFunc() {
      this.$eventBus.$emit('ceiba:common:events:club-fill', {});
    },
    // 快捷方式
    showAccessMakeAppShortCutFunc() {
      this.$eventBus.$emit('ceiba:custom:events:call:use:add:shortcut', {});
    },
    // 暂存箱配置tab
    resourceIssueFun() {
      let resourceIssue = {};
      if (this.configurationData.isResourcesIssue) {
        resourceIssue = {
          flow_version: 1,
          tab_title: {
            tabTitleAms: this.configurationData.tabTitleAms,
            tabTitleResourcesRecord: this.configurationData.tabTitleResourcesRecord,
          },
          isResourcesIssue: this.configurationData.isResourcesIssue, // 是否开启暂存箱tab
          isSandbox: this.configurationData.isSandbox || 'no', // 是否为沙箱环境
        };
      }
      return resourceIssue;
    },
    async handleClaimRecord() {
      this.reportFunc('login_click', { type: 'flatten_gift' });
      const pageSize = this.configurationData.popupPageSize || 6; // 每页记录数可配置,默认6
      await baseComponents.pacakgeClaimRecords.showPackageClaimRecords(this.gameCode, {
        hidePackageIds: (this.configurationData.hidePackageIds || '').split(','),
        params: {
          activity_id: this.actInfo.activity_id.toString(),
          business_id: this.actInfo.ast,
          resource_id: this.configurationData?.resource_id ? `${this.configurationData.resource_id}` : '',
          flow_version: this.actInfo.flow ? parseInt(this.actInfo.flow, 10) : 1,
          moduleId: this.configurationData?.moduleId ? `${this.configurationData.moduleId}` : '',
          category: this.configurationData?.category ? `${this.configurationData.category}` : '',
          iExcludePackageId: this.configurationData?.iExcludePackageId ? `${this.configurationData.iExcludePackageId}` : '',
          scene: this.configurationData?.scene ? `${this.configurationData.scene}` : 'ceiba_act',
          ...this.resourceIssueFun(),
        },
        pageSize,
        option: {
          header: false,
          footer: false,
          height: this.isMobile ? '3.6rem' : 'auto',
          width: this.isMobile ? '7.2rem' : '500px',
          closeLocation: 'top-right',
          close: true,
          dialogStyle: Object.assign(
            {},
            {
              color: this.configurationData.recordsFontColor || '#000000',
              backgroundImage: `url(${this.configurationData.packageClaimBackgroundImage})`,
            },
          ),
        },
      });
    },
    async handleRechargeRecord() {
      if (!this.roleInfo.role_id && this.showRole) {
        this.$alert({ msg: '请先绑定角色' });
        return false;
      }
      const myRoleInfo = this.roleInfo;
      await baseComponents.rechargeRecord.showRechargeRecord({
        thisFlowRequest: this.flowRequest,
        myRoleInfo,
        payBusiness: this.configurationData.payBusiness,
        sellChannel: this.configurationData.sellChannel,
        flowId: this.configurationData.rechargeRecordFlowId,
        spInfo: '',
        pageSize: 6,
        option: {
          header: false,
          footer: false,
          height: '3.6rem',
          width: '7.2rem',
          closeLocation: 'top-right',
          close: true,
          dialogStyle: Object.assign(
            {},
            {
              color: this.configurationData.rechargeRecordFontColor || '#c20303',
              backgroundImage: `url(${this.configurationData.rechargeRecordBackgroundImage})`,
            },
          ),
        },
      });
    },
    reportFunc(key, obj) {
      if (this.$isInEditor && !this.isInPreview) return;
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj,
        };
        this.reportClickRaw(params);
      }
    },
    reportExposeFunc(key, obj) {
      if (this.$isInEditor && !this.isInPreview) return;
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventType: 1001,
          eventKey: key,
          eventData: obj,
        };
        this.reportClickRaw(params);
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
